"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PICTURE_FIELDS = void 0;
const client_1 = require("@apollo/client");
exports.PICTURE_FIELDS = (0, client_1.gql) `
  fragment PictureFields on Picture {
    id
    createdAt
    updatedAt
    name
    sensitive
    caption
    path
    path256
    path512
    overlayPath
    overlayPath256
    overlayPath512
    thumbhash
    index
    topicId
    topic {
      id
      name
      typeId
    }
  }
`;
